import React from 'react'
import styled from '@emotion/styled'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined'
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined'
import ShoppingCartCheckoutOutlinedIcon from '@mui/icons-material/ShoppingCartCheckoutOutlined'
import Box from '@mui/material/Box'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'
import PropTypes from 'prop-types'

import { OrderChangeState } from '../../../../../../types/order.type'

const StateStepIconStyledDiv = styled('div')(({ ownerState }) => {
  return {
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '2px',
    backgroundColor: ownerState.completed ? 'blue' : 'grey'
  }
})

function StateStepIcon(props) {
  // these props are passed down through MUI
  const { icon, completed, active } = props

  const ICONS = {
    1: <ShoppingBagOutlinedIcon />,
    2: <CreditScoreOutlinedIcon />,
    3: <ShoppingCartCheckoutOutlinedIcon />,
    4: <ShoppingBasketOutlinedIcon />,
    5: <EventOutlinedIcon />,
    6: <LocalShippingOutlinedIcon />,
    7: <CheckCircleOutlineOutlinedIcon />
  }

  const element = ICONS[String(icon)]
  return (
    <StateStepIconStyledDiv ownerState={{ completed, active }}>
      {element ?? icon}
    </StateStepIconStyledDiv>
  )
}

/**
 * @param {OrderChangeState} state
 * @param {boolean} isBold
 */
function prettyPrintState(state, isBold) {
  let stateValue = ''
  switch (state) {
    case OrderChangeState.ORDERED:
      stateValue = 'Order received'
      break
    case OrderChangeState.PAYMENT_RECEIVED:
      stateValue = 'Payment Received'
      break
    case OrderChangeState.PREPARING:
      stateValue = 'Preparing Order'
      break
    case OrderChangeState.READY_FOR_DELIVERY:
      stateValue = 'Ready for Delivery'
      break
    case OrderChangeState.SCHEDULED_FOR_DELIVERY:
      stateValue = 'Scheduled for Delivery'
      break
    case OrderChangeState.DELIVERY_IN_PROGRESS:
      stateValue = 'Order is on the way'
      break
    case OrderChangeState.DELIVERED:
      stateValue = 'Order has been delivered'
      break
    default:
      stateValue = state
      break
  }

  if (isBold) {
    return <strong>{stateValue}</strong>
  } else {
    return <span>{stateValue}</span>
  }
}

/**
 * @param {Object} props
 * @param {import('../../../../../../types/order.type').OrderModel} props.order
 */
function OrderStates(props) {
  const STATES = Object.values(OrderChangeState)

  const orderStatus = props.order.status
  const activeStep = STATES.findIndex((status) => orderStatus === status)

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {STATES.map((label, index) => {
          return (
            <Step key={label} completed={index <= activeStep}>
              <StepLabel StepIconComponent={StateStepIcon}>
                {prettyPrintState(label, label === orderStatus)}
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
    </Box>
  )
}

StateStepIcon.propTypes = {
  icon: PropTypes.number,
  completed: PropTypes.bool,
  active: PropTypes.bool
}

OrderStates.propTypes = {
  order: PropTypes.object
}

export default OrderStates
